class Events {
    // app
    static APP_DRAWER_OPEN = "app-drawer-open";
    static APP_DRAWER_TOGGLE = "app-drawer-toggle";
    static APP_BOTTOM_SHEET_OPEN = "app-bottom-sheet-open";
    static APP_BOTTOM_SHEET_TOGGLE = "app-bottom-sheet-toggle";
    static APP_DIALOG_OPEN = "app-dialog-open";
    static APP_SNACKBAR_MESSAGE = "app-snackbar-message";
    static APP_AUTH_SHOW = "app-auth-show";
}

export default Events;